import React,{useState} from "react";
import AuthPageLayout from "../../../components/AuthPageLayout";
import { useAppContext } from "../../../../../context/AppContext";
import { AnimatePresence } from "framer-motion";
import Transition from "../../../../../components/Transition";
import ButtonLoader from "../../../../../components/ButtonLoader";
import { Link } from "react-router-dom";
import { AccountActivationData } from "../network/api/AccountActivationData";


export default function EmailConfirmation({ setConfirmedID }) {
    const { appData } = useAppContext();
    
        const [formData, setFormData] = useState({
            email: "",
            app_id: appData.id,
        });
    
        const [errors, setErrors] = useState({});
        const [isLoading, setIsLoading] = useState(false);
        const [errorMessage, setErrorMessage] = useState("");
        const [errorStatus, setErrorStatus] = useState("");
    
        const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setFormData({
                ...formData,
                [name]: type === "checkbox" ? checked : value,
            });

            if (errors[name]) {
                setErrors({ ...errors, [name]: null });
            }
        };
        const handleSubmit = async (e) => {
            setErrorMessage("");
            setErrorStatus("");
            setIsLoading(true);
            e.preventDefault();
            try{
                //console.log("Form Data:", formData);
                const response = await AccountActivationData(formData);
                if (response.status === "success") {
                    if(response.data.status === "active") {
                        setErrorMessage("Account already activated. You can now log in.");
                        setTimeout(() => {
                            window.location.href = "/login";
                        }, 1000);
                    }else {
                        setConfirmedID(response.data.user_id);
                    }

                } else {
                    setErrorMessage(response.message);
                    setErrorStatus("error");
                }
                setIsLoading(false);
            }catch (error) {
                setIsLoading(false);
                setErrorMessage("An error occurred while processing your request.");
                setErrorStatus("error");
                return;
            }
        };
    
        
    return (
        <AuthPageLayout>
            <h4 className="text-center mb-4"> Activate Your Account</h4>

            {!isLoading && errorMessage ? (
                <AnimatePresence mode="wait">
                    <Transition key={"error-message"}>
                        <div className={`alert alert-${errorStatus === "error" ? "danger" : "success"} alert-dismissible alert-alt solid fade show`}>
                            <strong>{errorStatus === "error" ? "Error!" : "Success!"}</strong> {errorMessage}
                        </div>
                    </Transition>
                </AnimatePresence>
            ) : null}

            <form onSubmit={handleSubmit}>
                <div className="mb-3">

                    <input
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        placeholder="example@email.com"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>


                <div className="text-center mb-3">
                    <button type="submit" className="btn btn-primary btn-block" disabled={isLoading }>
                        {isLoading ? <ButtonLoader /> : "Activate"}
                    </button>
                </div>

            </form>
            <div className="new-account mt-3">
                <p>Back to <Link className="text-primary" to="/login">Sign in</Link></p>
            </div>
        </AuthPageLayout>
    );
}
